import { translations } from 'locales/i18n';
import * as yup from 'yup';

export const ioEventValidationSchema = t =>
  yup.object().shape({
    eventName: yup.string().required(t(translations.validation.required())),
    eventDate: yup.date().required(t(translations.validation.required())),
    eventOfficer: yup.string().required(t(translations.validation.required())),
    eventOfficerEmail: yup.string().required(t(translations.validation.required())),
    meetingPoint: yup.string().required(t(translations.validation.required())),
    registrationDeadline: yup.date().required(t(translations.validation.required())),
    eventDescription: yup.string().notRequired().nullable(),
    participants: yup
      .array()
      .of(yup.string())
      .min(1, t(translations.validation.minOne()))
      .required(t(translations.validation.required())),
    costs: yup.string().required(t(translations.validation.required()))
  });
